import script from "./MultiSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiSelect.vue?vue&type=script&setup=true&lang=js"

import "./MultiSelect.vue?vue&type=style&index=0&id=bf1ed1b2&lang=css"

const __exports__ = script;

export default __exports__